import * as React from 'react';

import { UserMenuItem } from './UserMenuItem';
import { User } from '../../../common/models';
import { ErrorLogger } from '../error';
import { Search } from '../';

interface UserSearchProps {
  placeholder: string;
  errorLogger: ErrorLogger;
  onSearch(query: string): Promise<User[]>;
  onSelect(user: User): void;
}

export const UserSearch = ({ onSearch, onSelect, errorLogger, placeholder }: UserSearchProps) => {
  const fetchUsers = async (query: string): Promise<User[]> => {
    try {
      return onSearch(query);
    } catch (err) {
      await errorLogger.log(err);
      return [];
    }
  };

  const renderDropdownItem = (user: User) => <UserMenuItem user={user}/>;

  return (
    <Search
      renderSuggestion={renderDropdownItem}
      load={fetchUsers}
      onSelect={onSelect}
      placeholder={placeholder || 'Search'}
      highlightFirst={true}
    />
  );
};



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/UserSearch.tsx